export enum ResponseColour {
  RED,
  YELLOW,
  BLUE,
  WHITE,
  GREEN,
  GREY,
  PURPLE,
}
